import { Dispatch, SetStateAction } from 'react';
import { FlexProps } from 'rebass';

export const filterBarVariants = {
  container: {
    justifyContent: 'space-between',
    mb: 4,
    // Debug
    // bg: 'lime',
    // '> *:first-child': {
    //   bg: 'blue',
    // },
    // '> *:last-child': {
    //   bg: 'purple',
    // },
  },
  left: {
    flexWrap: 'wrap',
    flexShrink: 1,
    columnGap: [1, 1, 1, 2],
    rowGap: 2,
  },
  right: {
    ml: 3,
    flexShrink: 0,
    alignItems: 'flex-start',
  },
};

export type FilterBarProps<T> = FlexProps & {
  filters: T;
  setFilters: Dispatch<SetStateAction<Partial<T> | null>>;
  selectedId?: string;
};
